import styled from 'styled-components';
import { Card } from '../design-system';

export default styled(Card.Header)`
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
